var render = function render(){var _vm=this,_c=_vm._self._c;return _c('intervencion-activa-list-component',{attrs:{"tipo-modulo":_vm.TIPO_MODULO_INTERVENCION.ARMERIA}})
}
var staticRenderFns = []

export { render, staticRenderFns }